import { NewPassword } from './NewPassword';
import React from 'react';
import { Rule } from 'antd/es/form';

import { AUTOCOMPLETE, MESSAGES_COPY, PASSWORD } from '@sonar-software/sonar-ts-constants';
import { Form, Input, InputProps } from 'antd';

const rules: Rule[] = [
	{
		max: PASSWORD.MAX_LENGTH,
		message: MESSAGES_COPY.PLEASE_ENTER_NEW_PASSWORD,
		min: PASSWORD.MIN_LENGTH,
		pattern: PASSWORD.PATTERN,
		required: true,
		type: 'string'
	}
];

const confirmRules: Rule[] = [
	{
		message: PASSWORD.REQUIRED_MESSAGE_CONFIRM,
		required: true
	}
];

export interface ConfirmPasswordProps extends InputProps {
	disabled?: boolean;
	errorAlert?: React.ReactNode;
	id?: string;
	name?: string;
}

export const ConfirmPassword: React.FC<ConfirmPasswordProps> =
	({ disabled, errorAlert, id, name = 'password', ...props }) =>
		<>
			<Form.Item
				id={ id }
				name={ name }
				rules={ rules }>
				<NewPassword
					autoComplete={ AUTOCOMPLETE.NEW_PASSWORD }
					{ ...props }
					disabled={ disabled } />
			</Form.Item>
			{ errorAlert }
			<Form.Item
				dependencies={ [ name ] }
				id={ `${id}-confirm` }
				name='confirmPassword'
				rules={ [
					...confirmRules,
					({ getFieldValue }) => ({
						validator(_, value) {
							if (!value || getFieldValue(name) === value) {
								return Promise.resolve();
							}

							return Promise.reject(MESSAGES_COPY.PASSWORDS_DO_NOT_MATCH);
						}
					})
				] }>
				<Input.Password
					autoComplete={ AUTOCOMPLETE.NEW_PASSWORD }
					{ ...props }
					disabled={ disabled }
					placeholder={ PASSWORD.PLACEHOLDER_CONFIRM } />
			</Form.Item>
		</>;

